var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import { Emit } from "vue-property-decorator";
import { State } from "vuex-class";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import DataForm from "~/components/common/data-form.vue";
import DataBox from "~/components/common/data-box.vue";
import ImportCaseCommon from "~/components/case-manage/import-case-common.vue";
import { UploadFileService } from "~/services/common-service/upload-file.service";
import { DataImportService } from "~/services/dataimp-service/data-import.service";
var WorkListImportList = /** @class */ (function (_super) {
    __extends(WorkListImportList, _super);
    function WorkListImportList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 导入类型
        _this.templateType = "WORK_ORDER_IMPORT";
        _this.searchModel = {
            principalId: "",
            batchNumber: "",
            status: "",
            type: _this.templateType,
        };
        /**弹窗 */
        _this.dialog = {
            importCase: false,
            importCaseDetail: false,
        };
        _this.dataSet = [];
        _this.batchNumber = "";
        _this.loading = {
            state: false,
        };
        return _this;
    }
    WorkListImportList.prototype.mounted = function () {
        var _this = this;
        this.refreshData();
        // 收到消息通知时更新未读消息
        this.$reminder.addImportListener().subscribe(function (data) {
            if (data === "IMPORT_WORKER_ORDER" || data === "IMPORT_WORKER_CONFIRMED") {
                var self = _this;
                setTimeout(function () {
                    self.refreshData();
                }, 2000);
            }
        });
    };
    WorkListImportList.prototype.refreshData = function () {
        var _this = this;
        this.dataImportService.findAllDataImportResult(this.searchModel, this.pageService, this.loading).subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    /**
     * 案件导入
     */
    WorkListImportList.prototype.caseImportDialogOpen = function () {
        this.dialog.importCase = true;
    };
    /**
     * 错误信息下载
     */
    WorkListImportList.prototype.errorTipsDownload = function (row) {
        var _this = this;
        this.uploadFileService.getFileStreamById(row.fileId).subscribe(function () { return _this.$message.success("下载成功"); });
    };
    /**
     * 取消导入
     */
    WorkListImportList.prototype.cancelImport = function (data) {
        var _this = this;
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u53D6\u6D88\u5BFC\u5165" + data.batchNumber + "\u6279\u6B21\u7684\u5DE5\u5355\u5417\uFF1F", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        })
            .then(function () {
            _this.loading.state = true;
            _this.dataImportService.cancelImportWorkOrder(data.id, _this.loading).subscribe(function (data) {
                _this.$message.success("取消导入成功!");
                _this.refreshData();
            });
        })
            .catch(function (ex) { });
    };
    /**
     * 工单撤销
     */
    WorkListImportList.prototype.revertCick = function (row) {
        var _this = this;
        this.$confirm("确认要对此批次进行撤销", "提示").then(function () {
            _this.loading.state = true;
            _this.dataImportService.cancelBatchWorkImport(row.id, _this.loading).subscribe(function (data) {
                _this.$message.success("操作成功");
                _this.refreshData();
            });
        });
    };
    /**
     * 确认导入
     */
    WorkListImportList.prototype.confirmImport = function (data) {
        var _this = this;
        this.$confirm("您确定要导入此工单信息吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(function () {
            _this.loading.state = true;
            _this.dataImportService.confirmImportWorkOrder(data.id, _this.loading).subscribe(function (data) {
                _this.$message.success("正在确认!"), _this.refreshData();
            });
        });
    };
    /**
     * 查看详情
     */
    WorkListImportList.prototype.viewDetail = function (rowData) { };
    __decorate([
        Dependencies(PageService)
    ], WorkListImportList.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], WorkListImportList.prototype, "sortService", void 0);
    __decorate([
        Dependencies(UploadFileService)
    ], WorkListImportList.prototype, "uploadFileService", void 0);
    __decorate([
        Dependencies(DataImportService)
    ], WorkListImportList.prototype, "dataImportService", void 0);
    __decorate([
        State
    ], WorkListImportList.prototype, "principalList", void 0);
    __decorate([
        Emit("onClickCaseDetail")
    ], WorkListImportList.prototype, "viewDetail", null);
    WorkListImportList = __decorate([
        Layout("workspace"),
        Component({
            components: {
                DataForm: DataForm,
                DataBox: DataBox,
                ImportCaseCommon: ImportCaseCommon,
            },
        })
    ], WorkListImportList);
    return WorkListImportList;
}(Vue));
export default WorkListImportList;
